export const getAddressLayer = (property: string, addWord?: string): string => {
    let text: string = " ";
    if (property) {
        text = `${property}${addWord ? addWord : " "}`;
    }
    return text.trim();
};
